<section class="app-panel-shell">
  <header
    class="app-panel-head"
    *ngIf="title || subtitle || sectionTag || collapsible"
  >
    <div class="app-panel-head-content">
      <h3 *ngIf="title">{{ title }}</h3>
      <p *ngIf="subtitle">{{ subtitle }}</p>
    </div>

    <div class="app-panel-head-side" *ngIf="sectionTag || collapsible">
      <span class="app-panel-section-tag" *ngIf="sectionTag">{{ sectionTag }}</span>

      <button
        *ngIf="collapsible"
        type="button"
        class="app-panel-toggle"
        [class.app-panel-toggle--collapsed]="isCollapsed"
        [attr.aria-label]="collapseButtonLabel"
        [attr.aria-expanded]="!isCollapsed"
        (click)="toggleCollapse()"
      >
        <svg class="app-panel-toggle-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <path d="M3.5 10.25L8 5.75l4.5 4.5" />
        </svg>
      </button>
    </div>
  </header>

  <div class="app-panel-body-wrap" [class.app-panel-body-wrap--collapsed]="isCollapsed">
    <div class="app-panel-body">
      <ng-content></ng-content>
    </div>
  </div>
</section>
